<template>
  <span>
  </span>
</template>

<script>

import Swal from "sweetalert2";
import {
  getThisAdminInformation,
} from "../services/APIService";

export default {
  data() {
    return {
    };
  },
  mounted() {
    // Let's just do a simple call to REST API to find out if our token has expired.
    getThisAdminInformation()
    .then(resp => {
      this.$store.commit({
        type: "setUserRole",
        userRole: resp.role,
      });

      this.$store.commit({
        type: "setUserCompany",
        userCompany: resp.company_name,
      });

      this.$store.commit({
        type: "setUserEnableDemoGames",
        userEnableDemoGames: resp.company_enable_demo_games,
      });

      this.$store.commit({
        type: "setUserEnableComments",
        userEnableComments: resp.can_enable_comments,
      });

      this.$store.commit({
        type: "setUserEnableSurvey",
        userEnableSurvey: resp.can_enable_survey,
      });

      this.$store.commit({
        type: "setUserEnableBilling",
        userEnableBilling: resp.can_enable_billing,
      });
      this.$store.commit({
        type: "setUserAddRobots",
        userAddRobots: resp.can_add_robots,
      });

      this.$store.commit({
        type: "setUserViewObserverLink",
        userViewObserverLink: resp.can_view_observer_link,
      });

      this.$store.commit({
        type: "setUserCustomizeSimulations",
        userCustomizeSimulations: resp.can_customize_simulations,
      });

      this.$store.commit({
        type: "setUserViewGamesHistory",
        userViewGamesHistory: resp.can_view_games_history,
      });

      this.$store.commit({
        type: "setUserCreateRPSSimulations",
        userCreateRPSSimulations: resp.can_create_rps_simulations,
      });

      this.$store.commit({
        type: "setUserCreateGameInstructions",
        userCreateGameInstructions: resp.create_game_instructions,
      });

      this.$store.commit({
        type: "setUserEditRPSScenarios",
        userEditRPSScenarios: resp.can_edit_rps_scenarios,
      });            

      this.$store.commit({
        type: "setUserEnableCombinationReports",
        userEnableCombinationReports: resp.can_enable_combination_reports,
      });

      this.$store.commit({
        type: "setUserViewSimulationBrowser",
        userViewSimulationBrowser: resp.can_view_simulation_browser,
      });

      this.$store.commit({
        type: "setLimitedFacilitatorAllowedCreateGameScenarioId",
        limited_facilitator_allowed_create_game_scenario_id: resp.limited_facilitator_allowed_create_game_scenario_id,
      });

      this.$store.commit({
        type: "setLimitedFacilitatorAllowedCreateGameRpsScenarioId",
        limited_facilitator_allowed_create_game_rps_scenario_id: resp.limited_facilitator_allowed_create_game_rps_scenario_id,
      });

      this.$store.commit({
        type: "setUserCompanyLogo",
        userCompanyLogo: resp.company_logo,
      });      
    })
    .catch(error => {
      // If 401 due to expired token, let's show dialog and go to login page
      if (error.response && error.response.status === 401) {
          Swal.fire({ text: this.$t("loginexpired"), allowOutsideClick: false });
          this.$store.dispatch("logout");
          this.$router.push("/admin/login/expired/1");
      } else {
          throw (error)
      }
    });
  },
  computed: {

  },
  methods: {
  }
};
</script>

<i18n>
{
  "en": {
    "loginexpired": "Your login has expired. Please login again."
  },
  "fi": {
    "loginexpired": "Sisäänkirjautumisesi on vanhentunut. Kirjauduthan uudestaan."
  }
}
</i18n>
